module.exports = {
  language: "English(US)",

  //确认支付按钮
  components_confirmPay_btn: {
    notYet: "Not Yet",
    waitingTips: "Waiting for your payment ",
  },

  //买币阿根廷支付
  ArgentinaPay: {
    BankName: "Bank Name",
    ChooseBank: "Choose your Bank",
    selectcard: "Please select a bank",
    BankAccount: "Bank Account",
    cardnumber: "Please enter the correct card number",
    Bankcode: "Bank code",
    correctcode: "Please enter the correct code",
    ID: "ID",
    SelectBank: "Select Bank",
    phone: "phone Number",
    phoneTips: "Invalid phone number!",
    paymentResultError:
      "The bank account information is incorrect. Please check and purchase again.",
    Choose: "Choose your account type",
    chequing: "chequing",
    Saving: "Saving",
    Amount: "Amount:",
    AccountNumber: "Account number",
    BankCode: "Bank Code",
    fullNameTips: "Invalid full name",
    idTips: "Invalid ID number",
  },
  //买币结果页(暂时不用)
  // payResult: {
  //   //支付结果提示
  //   tipsText_40010: 'Card data inaccurate. Please check card information.',
  //   tipsText_40011: 'Card data inaccurate. Please check card information.',
  //   tipsText_40019: 'Card data inaccurate. Please check card information.',
  //   tipsText_40020: 'Insufficient fund',
  //   tipsText_40030: 'Card jurisdiction is restricted. Please try another card.',
  //   tipsText_40031: 'Card restricted',
  //   tipsText_40032: 'Card abnormality',
  //   tipsText_40033: 'Card restricted',
  //   tipsText_40034: 'Card restricted, risk control.',
  //   tipsText_40090: 'Abnormal rejection',
  // },

  //菜单
  menu: {
    home: "Home",
    menu: "Menu",
    transactions: "Transactions",
    language: "Language",
    privacy: "Privacy Policy",
    logOut: "Log Out",
    service: "Terms of Service",
    RouterMenu_experience: "Login to unlock the full experience",
    login_Youlogged: "You re already logged in",
    RouterMenu_Welcome: "Welcome to Alchemy Pay!",
    RouterMenu_history: "No history yet",
    loginOut_Dismiss: "Dismiss",
    loginOut_title: "Are you sure you want to logout?",
  },

  //导航文案
  navTabTitle: {
    Completepayment: "Complete the payment",
  },

  //按钮组件
  button_components: {
    proceed: "Proceed",
  },

  //---------------------------- 支付方式信息组件 ----------------------------
  PayMethodInfo_components: {
    title: "Order summary",
    title2: "Your chosen payment method is",
  },
  //---------------------------- 扫码QR Code组件 ----------------------------
  QrCode_components: {
    title1: "Pay",
    title2: "to completed your purchuse.",
    title3:
      "Please open your payment application and scan the QR code below to complete the payment.",
    copy: "COPY",
  },
  //---------------------------- 钱包地址和网络信息组件 ----------------------------
  WalletAddress_components: {
    title1: "Your",
    title2: "wallet",
  },
  //---------------------------- 表单信息 ----------------------------
  formInfo: {
    //新增
    fullName_placeholder: "Enter the full name",
    phone_title: "Please enter your phone number",
    id_title: "Enter the ID number",
    id_placeholder1: "Enter the",
    id_placeholder2: "digit ID number",
    bankAccount_placeholder: "Choose your account type",
    accountNumber_placeholder: "Enter the 22 digit ID number",
    bankCode_placeholder: "Enter the 3 digit ID number",
    //vnd 选择bank code
    vnd_bankCode_placeholder: "Choose bank code",
    select_id_placeholder: "Choose your ID type",
  },

  //vnd新增文案 越南支付文案
  vndChildren: {
    amount: "Amount",
    oneTitle: `Go to the banking app , scan the QRcode or enter the recipient's id manually`,
    twoTitle: " Fill in the transfer content in the message box",
    threeTitle: " make a money transfer",
    Accountname: "Account name",
    AccountID: "Account ID",
    Transfercontent: "Transfer content",
  },

  //菲律宾页面
  phpPayment: {
    PaymentGuide: "Payment Guide",
    BillNumber: "Digital Remit number",
    PAYSO1: 'Enter Gcash wallet, click "Bills" and select bill payment',
    PAYSO2: 'Search and select "PAYSO"',
    PAYSO3: "fill in these informations, and click [NEXT]",
    Incorrect:
      "Please ensure the amount you transfer to us is accurate. Incorrect information or amount will cause fail order or fund loss.",
  },

  // TRY银行转账表单信息
  TRY_form: {
    // TRY银行转账
    nationality_title: "Enter the nationality",
    authCardNo_title: "Enter the ID number",
    firstName_title: "Enter the First name",
    lastName_title: "Enter the Last name",
    address_title: "Enter the Address",
    birthday_title: "Enter the Birthday",
    authCardNo_tips: "Invalid ID number",
    firstName_Tips: "Invalid First name",
    lastName_tips: "Invalid Last name",
    address_tips: "Invalid Address",
    birthday_tips: "Invalid Birthday",
    address_Placeholder: "Same with the address on your ID card",
    ID_CARD: "ID Card",
    DRIVER_LICENSE: "Driver license",
    PASSPORT: "Passport",
  },

  // KRW银行转账表单信息
  KRW_form: {
    // TRY银行转账
    nationality_title: "Enter the nationality",
    authCardNo_title: "Enter the ID number",
    firstName_title: "Enter the First name",
    lastName_title: "Enter the Last name",
    address_title: "Enter the Address",
    birthday_title: "Enter birthday (day/month/year)",
    authCardNo_tips: "Invalid ID number",
    firstName_Tips: "Invalid First name",
    lastName_tips: "Invalid Last name",
    address_tips: "Invalid Address",
    birthday_tips: "Invalid Birthday",
    address_Placeholder: "Same with the address on your ID card",
    RESIDENT_REGISTRATION_NUMBER: "ID Card",
    DRIVER_LICENSE: "Driver license",
    PASSPORT_NUMBER: "Passport",
    ALIEN_REGISTRATION_NUMBER: "Alien residence permit",
    DOMESTIC_RESIDENCE_REPORT_NUMBER: "Domestic residence report",
  },

  //---------------------------- 用户支付信息组件 ----------------------------
  TraderInformation: {
    title: "Trader Information",
  },

  //选择支付方式页
  buyPayWay: {
    BINANCEPAY: "BINANCE PAY",
    qrCode: "QR Code",
    Khipu: "Bank Transfer",
    ThaiQR: "ThaiQR",
    Philippines: "Bank Transfer",
    saas: "PayNow",
    pix: "PIX",
    ChangeCard: "Change bank card",
    recentlyUsed: "Saved Payment Method",
    paymentMethod: "Add a New Payment Method",
    towMethod: "Change payment method",
    rampFee: "Processing Fee",
    card: "Card",
    card1: "Card",
    creditCard: "Credit Card",
    bankTransfer: "Prompt Pay",
    bancoTransfer: "Banco Transfer",
    opm: "SPEI(OPM)",
    virtualAccount: "Bank Transfer",
    eWallet: "E-Wallet",
    binancePay: "BINANCE PAY",
    applePay: "Apple Pay",
    googlePay: "Google Pay",
    promptPay: "Prompt Pay",
    addCardTitle: "Add New Card",
    useCardTitle: "Use new card",
    edit: "Edit",
    cancel: "Cancel",
    support: "Support",
    cardLimitTips: "6 Cards Limit Reached",
    kaKaoPay: "KaKao Pay",
    GCash: "Bank Transfer",
    touchNGo: "Touch n go",
    payNow: "Pay Now",
    Unavaible: "Unavaible",
    limit: "Limit",
    proceed: "Proceed",
    deleteTips: "Successfully deleted",
  },

  //买币信用卡表单组件
  components_buyForm: {
    formTitle: "Enter your card details.",
    firstName: "First Name",
    lastName: "Last Name",
    nameTips: "Invalid Name!",
    cardNumber: "Card Number",
    cardNumTips: "Please enter a valid card number.",
    expirationDate: "Expiration Date",
    dataTips: "Invaid expiry date",
    cvv: "CVV",
    cvvTips: "Please enter a valid CVV",
  },

  //国际卡确定订单页
  creditCard: {
    payingWith: "Paying with",
    card: "Card",
    cvv: "CVV",
  },

  //买币确定订单页 - 巴西支付
  configPay_brl: {
    phoneNumber: "Cell phone Number",
    fullName: "Full Name",
    formTitle: "Enter your details.",
    code_tips: "Scan QR code via your PIX to complete the payment.",
    name_tips: "Invalid Name!",
    id_tips: "Invalid Id!",
    number_tips: "Invalid Cell phone Number!",
    selectCountry: "Select Country",
  },

  //确认订单页 - 墨西哥支付
  opmPayment: {
    banco: "Banco",
  },

  //---------------------------- 银行转账收银台 ----------------------------
  cashierDesk_bankTransfer: {
    tiemOut: "The order will be cancelled in {0} {1}",
    PleasePay: "Please Pay",
    title1: "Open your bank application . Enter this reference number  ",
    title2: "Enter the account registration information",
    CLABEinterbancaria: "CLABE interbancaria:",
    Destinationbank: "Destination bank:",
    Beneficiary: "Beneficiary:",
    Payamount: "Pay amount:",
    title3:
      "If your payment is not completed for a long time, we suggest you upload the payment documents to our customer service. This will speed up our confirmation of your payment.",
  },

  //弹出框文案
  components_payConfig: {
    title_THB: "Payment in progress",
    button_THB: "Check Order",
    button_timeOut: "Back to Home Page",
    button_timeOut1: "Back to Home",
    double: "Please do not make double payment",
    completed: "Please confirm that your transfer has been completed.",
    timeorder: "This order is out of time.",
    checkout: "Are you sure leave checkout counter?",
    buttonLeave: "Close Order",
  },

  //买币历史订单页+买币订单详情页
  buyHistory: {
    buyPrice: " Price ",
    buyTotal: "Total ",
    buyOrderID: "Order ID",
    buyOrdeTime: "Order Time",
    buyPaymentTime: "Payment Time",
    buyPayerAccount: "Payer Account",
    buyCompleted: "Completed",
    buyFailed: "Failed",
    buyClosed: "Closed",
    history_noListText: "No transactions",
    history_noListButton: "Buy NFT now",
    history_noMore: "No more",
  },

  //登陆页
  loginPage: {
    enterEmail: "What is your email address?",
    enterEmail1: "Is this your email address?",
    emailanother: "Sign in with another email address",
    emailNotyou: "Not you?",
    codeTitle1: "Enter the login code you just received",
  },
  nav: {
    //买币确认订单文案提示
    buyConfigPaytitle: "By continuing you agree to our ",
    /**
     * 按钮文案
     */
    Continue: "Continue",
    Confirm: "Confirm",
    ConfirmPayment: "Confirm the Payment",
    queryOderState: "I have completed the payment",
    Proceed: "Proceed",

    //风险账户文案
    accountTraded: "This account is at risk and cannot be traded now.",
    /**
     * 路由
     */
    routerName_Transactions: "Order History",
    routerName_paymentMethod: "Choose payment method",
    routerName_creditCardConfig: "Confirm Payment",
    routerName_buyPayment: "Payment",
    routerName_buyOtherWayPay: "Confirm your payment",
    routerName_paymentResult: "Payment Result",
    routerName_kycOnfido: "ID Proof & Selfie",
    routerName_kycSumsub: "ID Proof & Selfie & POA",

    /**
     * 组件
     */
    networkAddress_components_title: "address",

    /**
     * 登陆
     */
    login: "Login",
    login_required: "Format Error.",
    login_necessary: "necessary",

    loginTitle1: "Checkout with Alchemy Pay",
    loginTitle2:
      "The fastest and safest way to checkout on hundreds of crypto apps.",

    codeTitle2: "Not received? ",
    codeTitle3: "New verification code sent ",
    codeSecond: "s",
    code_text: " I have read and agree to Alchemy pay's ",
    code_and: "and",
    code_name2: "Privacy Policy",

    /**
     * 首页
     */
    copyTips: "copy success",

    //买币 - 确认订单 - 国际卡
    buy_configPay_title1: "Paying with",

    //买币 - 确认订单 - 印尼支付
    buy_configPayIDR_va_title: "BANK",
    buy_configPayIDR_va_codeTitle: "Payment Code",
    buy_configPayIDR_codeTips: "Scan QR Code to complete payment",
    buy_configPayIDR_ovo_phoneTips: "Open OVO app to complete payment.",

    // 后增
    search_components_placeHolder: "Search here… ",
    buy_configPayIDR_ovo_title: "OVO Phone",
    login_getCode: "Resend code",
    login_VerifyCode: "Please enter the six-digit verification code",
    login_Agreement: "Please tick the User Agreement",
  },

  //确认订单通用
  confirmOrder: {
    pleasePay: "Please Pay",
  },

  //首页
  homePage: {
    purchaseNFT: "Purchase NFT",
    item: "ITEM",
    quantity: "Quantity",
    youPay: "You Pay",
    proceedBuy: "Proceed · Buy ",
    selectCurrency: "Select Currency",
    tiemErrToast: "The order timed out and the next step cannot be made",
    USDTips:
      "Currently does not support USD, please choose other fiat currency",
  },

  //交易历史
  transactionHistory: {
    buy: "Buy",
    item: "ITEM",
    price: "Price",
    quantity: "Quantity",
    total: "Total",
    uniqueId: "uniqueId",
    loading: "Loading",
    loadingFailed: "Loading failed",
  },
  //等待组件
  buypayWait: {
    Processing: "In Processing",
    progress: "Order in progress",
    purchase: "To purchase this item for ",
    transaction: "Complete this final transaction!",
  },
  //结果页
  payResult: {
    buttonText: "Come Back to ",
    goHistory: "View order history",
    closed1: "This order is time out.",
    closed2: "Plesae place the order again",
    failed1: "Payment Failed!",
    failed2: "The information is wrong and has been reject by bank.",
    failed1010:
      "The payment amount doesn't match the current payment method limit",
    success1: "Thank You!",
    success2: "Purchase was successfull.",
    success3: "We have send you an email with order details.",
    waitTips: "Waiting for payment",
  },

  //费用信息组件
  buyFee_components: {
    codeSecond: "s",
    title: "Purchasing NFT for",
    rampFee: "Processing Fee",
    rampFeeTips: "as low as",
    networkFee: "Network Fee",
    tips: "This is charged by AlchemyPay to cover costs associated with payment processing. This may vary based on the payment method you choose later.",
  },

  // kyc_onfido
  kycAlert: {
    waiting_msg: "Your ID Proof & Selfie is under review:",
    success_msg: "Identity Verification Successed",
    failure_msg: "Resubmit related Documents",
  },
  kycStatus: {
    account: "Account:",
    login_time: "Last login time:",
    verify_succeeded: {
      tips: "Identity Verification Successed",
      content:
        "Congratulations! All submit docunments pass the verification process. Your daily trading limit has been incress to equivalent amount of {0}",
      process: "Process",
    },
    verify_exception: {
      tips: "Resubmit related Documents",
      update_document: "Update documents",
    },
    verify_failed: {
      tips: "Identity Verification Rejected",
    },
    verify_waiting: {
      received_documents: "We have received your KYC documents.",
      notify_you:
        "We will notify you once verification result through email. It will normally take 5 to 10 min. In rare cases, manual re-audit will be conducted. Manual review will be completed within 24 hours.",
      leave: "Leave Now",
      under_review: "Under Review...",
      estimated_time: "Estimated waiting time:",
      waiting_time: "You have waitting for:",
      reviewed_now: "The documents you submitted are being reviewed right now.",
    },
  },

  //kyc验证页面
  kycVerificationFonts: {
    kycminutestitle:
      "Please verify your identity. It usually takes about 2 minutes.",
    kycPrepareyour: "Prepare your ID",
    kycminutesdocument: "Get ready to take a selfie with document.",
    kycButtonminutes: "Begin Verification",
    kyccompleted1: "Congrats! ",
    kyccompleted2: "Your verification completed.",
    kycButtoncompleted: "Continue the Payment",
    kycPayLimitUpTips: "Payment limit up to",
    kycError: "Your verification failed.",
    kycRiskAccount: "The account is at risk and cannot be traded now.",
    kycButtonError: "Back to Home Page ",
    kycButtonTryAgain: "Try Again",

    kyc2_startTitle: "Please provide your address material.",
    kycErrorTips: "Please make sure your address is genuine and verifiable",
    kycErrorTryAgain_title: "Your verification failed.",
    kycErrorTryAgain_tipsTitle: "Please ensure",
    kycErrorTryAgain_tips1: "You submitted your own ID document.",
    kycErrorTryAgain_tips2:
      "The name on your ID document is identical to your payment's cardholder name.",
    kycErrorTryAgain_tips3:
      "You did not use multiple ID documents for the KYC verification.",
  },
};
